//import "./EmbededRegisterPage.css";
import { useEffect, useState } from "react";
import RegisterComponent from "../../components/home/basic_register/RegisterComponent";
import { Card, CardBody } from "react-bootstrap";
import RegisterComponentV2 from "../../components/home/basic_register/RegisterComponentV2";

const EmbededRegisterPage = () => {

    const [divHeight, setDivHeight] = useState(0);
    
    useEffect(() => {
        const element = document.getElementById('formBodyId');
        if (!element) return;

        const sendHeight = () => {
            const height = element.scrollHeight + 20;
            setDivHeight(height -50);
            window.parent.postMessage({ height }, "https://new.energiepool.at");
        };

        sendHeight();

        const observer = new ResizeObserver(() => {
            sendHeight();
        });

        observer.observe(element);

        return () => {
            observer.disconnect();
        }
    }, [])

    return (
        <div id="formBodyId" style={{ padding: 20}}>
            <RegisterComponentV2 />
        </div>
    )
}
export default EmbededRegisterPage;